/** @deprecated Import from '../quota' instead */
export { useCompanyQuotaQuery, invalidateCompanyQuotaQuery } from '../quota/useCompanyQuotaQuery';
